<template>
  <div class="side_bar__wrapper fix-navbar">
    <SuspendedModal
      :statusInfo="statusInfo"
      :branch="true"
      :industry="false"
    ></SuspendedModal>
    <WarningModal
      :statusInfo="statusInfo"
      :branch="true"
      :industry="false"
    ></WarningModal>
    <div
      class="side__bar"
      id="mlDiv"
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
    >
      <div class="side_bar_Logo text-center">
        <div class="text-center mt-3">
          <img src="@/assets/img/epump_white_logo.svg" width="150" />
        </div>
      </div>
      <div>
        <ul class="list-group mt-4">
          <!-- <li
            class="list-group-item"
            :class="
              activeRoute === 'branchDashboard' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{
                name: 'branchDashboard',
                query: { branchId: this.$route.query.branchId , companyId:this.$route.query.companyId },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="fa fa-arrow-left text-white"
                  aria-hidden="true"
                  width="20px"
                ></i
              ></span>
              <span class="sidenav_list_title"> Branch Dashboard </span>
            </router-link>
          </li> -->

          <!-- INDUSTRY ADMIN DASHBOARD -->
          <li
            style="font-size: 12px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_dashboard'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="this.$route.query.branchId && !this.$route.query.groupId"
          >
            <router-link
              :to="{
                name: 'industrial_admin_dashboard',
                query: {
                  companyID: this.$route.query.companyId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i></span
              >{{ $t("text.cDashboard.backCDashboard") }}
            </router-link>
          </li>

          <!-- INDUSTRY GROUP DASHBOARD -->
          <li
            style="font-size: 12px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_group_dashboard'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="this.$route.query.groupId"
          >
            <router-link
              :to="{
                name: 'industrial_group_dashboard',
                query: {
                  groupID: this.$route.query.groupId,
                  companyId: this.$route.query.companyId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i></span
              >{{ $t("text.omit.backToGroupDash") }}
            </router-link>
          </li>

          <!-- INDUSTRY BRANCH DASHBOARD -->
          <li
            style="font-size: 12px"
            class="list-group-item"
            :class="[
              activeRoute === 'IndustrialBranchDashboard'
                ? 'navbar_item_active'
                : null,
            ]"
          >
            <router-link
              :to="{
                name: 'IndustrialBranchDashboard',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img
                  alt=""
                  src="@/assets/img/dashboard (1).png"
                  width="20px" /></span
              >{{ $t("text.iMasterLayout.dashboard") }}
            </router-link>
          </li>

          <!-- <li
            style="font-size: 12px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrialBranchTanks'
                ? 'navbar_item_active'
                : null,
            ]"
          >
            <router-link
              :to="{
                name: 'industrialBranchTanks',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 0C10.751 0 0 10.751 0 24C0 37.249 10.751 48 24 48C37.249 48 48 37.249 48 24C48 10.751 37.249 0 24 0ZM24 1C36.708 1 47 11.292 47 24C47 36.709 36.708 47 24 47C11.292 47 1 36.709 1 24C1 11.292 11.292 1 24 1ZM24.5 12C24.3674 12 24.2402 12.0527 24.1464 12.1464C24.0527 12.2402 24 12.3674 24 12.5V14H23.5C23.3674 14 23.2402 14.0527 23.1464 14.1464C23.0527 14.2402 23 14.3674 23 14.5V16H21V13.506C21 13.3734 20.9473 13.2462 20.8536 13.1524C20.7598 13.0587 20.6326 13.006 20.5 13.006C20.3674 13.006 20.2402 13.0587 20.1464 13.1524C20.0527 13.2462 20 13.3734 20 13.506V16H15V16.025C11.642 16.285 9.033 19.323 9.033 23C9.033 25.541 10.283 27.773 12.16 29H8.506C8.3718 29 8.2431 29.0533 8.1482 29.1482C8.05331 29.2431 8 29.3718 8 29.506V31.496C8 31.776 8.226 32.002 8.506 32.002H11.187L12.049 33.725C12.0907 33.8078 12.1546 33.8773 12.2335 33.9259C12.3125 33.9744 12.4033 34.0001 12.496 34H13.046C13.1634 34.5635 13.4709 35.0694 13.9169 35.4332C14.363 35.7969 14.9204 35.9963 15.496 35.998C16.0717 35.9959 16.6293 35.796 17.0753 35.432C17.5213 35.0679 17.8287 34.5617 17.946 33.998H18.496C18.5887 33.9981 18.6795 33.9724 18.7585 33.9239C18.8374 33.8753 18.9013 33.8058 18.943 33.723L19.805 32H28.195L29.057 33.723C29.0987 33.8058 29.1626 33.8753 29.2415 33.9239C29.3205 33.9724 29.4113 33.9981 29.504 33.998H30.057C30.174 34.5617 30.4811 35.068 30.927 35.4321C31.3729 35.7962 31.9303 35.996 32.506 35.998C33.0818 35.9962 33.6395 35.7966 34.0856 35.4324C34.5317 35.0683 34.839 34.5618 34.956 33.998H35.504C35.5967 33.9981 35.6875 33.9724 35.7665 33.9239C35.8454 33.8753 35.9093 33.8058 35.951 33.723L36.812 32H39.494C39.774 32 40 31.774 40 31.494V29.02H39.494V29H35.84C37.718 27.773 38.967 25.541 38.967 23C38.967 19.154 36.116 16 32.535 16H29V14.5C29 14.3674 28.9473 14.2402 28.8536 14.1464C28.7598 14.0527 28.6326 14 28.5 14H28V12.5C28 12.3674 27.9473 12.2402 27.8536 12.1464C27.7598 12.0527 27.6326 12 27.5 12H24.5ZM25 13H27V14H25V13ZM24 15H28V16H24V15ZM16 17H17V29H16V17ZM18 17H30V29H18V17ZM31 17H32V29H31V17ZM15 17.025V28.975C12.224 28.717 10.033 26.18 10.033 23C10.033 19.82 12.224 17.283 15 17.025ZM33 17.025C35.776 17.283 37.967 19.82 37.967 23C37.967 26.18 35.776 28.717 33 28.975V17.025ZM9.012 30.012H38.988V30.99H9.012V30.012ZM12.307 32.002H13.507C13.287 32.294 13.123 32.629 13.047 33H12.807L12.307 32.002ZM15.477 32.002H15.516C16.341 32.013 16.996 32.672 16.996 33.5C16.996 34.334 16.33 35 15.496 35C14.662 35 13.996 34.334 13.996 33.5C13.996 32.672 14.652 32.012 15.476 32.002H15.477ZM17.484 32.002H18.687L18.187 33H17.945C17.8684 32.6371 17.7112 32.296 17.485 32.002H17.484ZM29.312 32.002H30.518C30.297 32.294 30.132 32.629 30.057 33H29.813L29.312 32.002ZM32.486 32.002H32.526C33.35 32.013 34.006 32.672 34.006 33.5C34.006 34.334 33.34 35 32.506 35C31.672 35 31.006 34.334 31.006 33.5C31.006 32.672 31.661 32.012 32.486 32.002ZM34.494 32.002H35.694L35.194 33H34.955C34.8784 32.6371 34.7202 32.296 34.494 32.002ZM15.496 33C15.3634 33 15.2362 33.0527 15.1424 33.1464C15.0487 33.2402 14.996 33.3674 14.996 33.5C14.996 33.6326 15.0487 33.7598 15.1424 33.8536C15.2362 33.9473 15.3634 34 15.496 34C15.6286 34 15.7558 33.9473 15.8496 33.8536C15.9433 33.7598 15.996 33.6326 15.996 33.5C15.996 33.3674 15.9433 33.2402 15.8496 33.1464C15.7558 33.0527 15.6286 33 15.496 33ZM32.506 33C32.3734 33 32.2462 33.0527 32.1524 33.1464C32.0587 33.2402 32.006 33.3674 32.006 33.5C32.006 33.6326 32.0587 33.7598 32.1524 33.8536C32.2462 33.9473 32.3734 34 32.506 34C32.6386 34 32.7658 33.9473 32.8596 33.8536C32.9533 33.7598 33.006 33.6326 33.006 33.5C33.006 33.3674 32.9533 33.2402 32.8596 33.1464C32.7658 33.0527 32.6386 33 32.506 33Z"
                    fill="white"
                  /></svg
              ></span>
              {{ $t("text.iBranchTank.tank") }}
            </router-link>
          </li> -->

          <!---------- TANK ---------------->
          <li
            style="font-size: 12px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrialBranchTanks' ||
              activeRoute === 'industrialBranchReorderLevel'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Tank') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><svg
                  width="28"
                  height="28"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 0C10.751 0 0 10.751 0 24C0 37.249 10.751 48 24 48C37.249 48 48 37.249 48 24C48 10.751 37.249 0 24 0ZM24 1C36.708 1 47 11.292 47 24C47 36.709 36.708 47 24 47C11.292 47 1 36.709 1 24C1 11.292 11.292 1 24 1ZM24.5 12C24.3674 12 24.2402 12.0527 24.1464 12.1464C24.0527 12.2402 24 12.3674 24 12.5V14H23.5C23.3674 14 23.2402 14.0527 23.1464 14.1464C23.0527 14.2402 23 14.3674 23 14.5V16H21V13.506C21 13.3734 20.9473 13.2462 20.8536 13.1524C20.7598 13.0587 20.6326 13.006 20.5 13.006C20.3674 13.006 20.2402 13.0587 20.1464 13.1524C20.0527 13.2462 20 13.3734 20 13.506V16H15V16.025C11.642 16.285 9.033 19.323 9.033 23C9.033 25.541 10.283 27.773 12.16 29H8.506C8.3718 29 8.2431 29.0533 8.1482 29.1482C8.05331 29.2431 8 29.3718 8 29.506V31.496C8 31.776 8.226 32.002 8.506 32.002H11.187L12.049 33.725C12.0907 33.8078 12.1546 33.8773 12.2335 33.9259C12.3125 33.9744 12.4033 34.0001 12.496 34H13.046C13.1634 34.5635 13.4709 35.0694 13.9169 35.4332C14.363 35.7969 14.9204 35.9963 15.496 35.998C16.0717 35.9959 16.6293 35.796 17.0753 35.432C17.5213 35.0679 17.8287 34.5617 17.946 33.998H18.496C18.5887 33.9981 18.6795 33.9724 18.7585 33.9239C18.8374 33.8753 18.9013 33.8058 18.943 33.723L19.805 32H28.195L29.057 33.723C29.0987 33.8058 29.1626 33.8753 29.2415 33.9239C29.3205 33.9724 29.4113 33.9981 29.504 33.998H30.057C30.174 34.5617 30.4811 35.068 30.927 35.4321C31.3729 35.7962 31.9303 35.996 32.506 35.998C33.0818 35.9962 33.6395 35.7966 34.0856 35.4324C34.5317 35.0683 34.839 34.5618 34.956 33.998H35.504C35.5967 33.9981 35.6875 33.9724 35.7665 33.9239C35.8454 33.8753 35.9093 33.8058 35.951 33.723L36.812 32H39.494C39.774 32 40 31.774 40 31.494V29.02H39.494V29H35.84C37.718 27.773 38.967 25.541 38.967 23C38.967 19.154 36.116 16 32.535 16H29V14.5C29 14.3674 28.9473 14.2402 28.8536 14.1464C28.7598 14.0527 28.6326 14 28.5 14H28V12.5C28 12.3674 27.9473 12.2402 27.8536 12.1464C27.7598 12.0527 27.6326 12 27.5 12H24.5ZM25 13H27V14H25V13ZM24 15H28V16H24V15ZM16 17H17V29H16V17ZM18 17H30V29H18V17ZM31 17H32V29H31V17ZM15 17.025V28.975C12.224 28.717 10.033 26.18 10.033 23C10.033 19.82 12.224 17.283 15 17.025ZM33 17.025C35.776 17.283 37.967 19.82 37.967 23C37.967 26.18 35.776 28.717 33 28.975V17.025ZM9.012 30.012H38.988V30.99H9.012V30.012ZM12.307 32.002H13.507C13.287 32.294 13.123 32.629 13.047 33H12.807L12.307 32.002ZM15.477 32.002H15.516C16.341 32.013 16.996 32.672 16.996 33.5C16.996 34.334 16.33 35 15.496 35C14.662 35 13.996 34.334 13.996 33.5C13.996 32.672 14.652 32.012 15.476 32.002H15.477ZM17.484 32.002H18.687L18.187 33H17.945C17.8684 32.6371 17.7112 32.296 17.485 32.002H17.484ZM29.312 32.002H30.518C30.297 32.294 30.132 32.629 30.057 33H29.813L29.312 32.002ZM32.486 32.002H32.526C33.35 32.013 34.006 32.672 34.006 33.5C34.006 34.334 33.34 35 32.506 35C31.672 35 31.006 34.334 31.006 33.5C31.006 32.672 31.661 32.012 32.486 32.002ZM34.494 32.002H35.694L35.194 33H34.955C34.8784 32.6371 34.7202 32.296 34.494 32.002ZM15.496 33C15.3634 33 15.2362 33.0527 15.1424 33.1464C15.0487 33.2402 14.996 33.3674 14.996 33.5C14.996 33.6326 15.0487 33.7598 15.1424 33.8536C15.2362 33.9473 15.3634 34 15.496 34C15.6286 34 15.7558 33.9473 15.8496 33.8536C15.9433 33.7598 15.996 33.6326 15.996 33.5C15.996 33.3674 15.9433 33.2402 15.8496 33.1464C15.7558 33.0527 15.6286 33 15.496 33ZM32.506 33C32.3734 33 32.2462 33.0527 32.1524 33.1464C32.0587 33.2402 32.006 33.3674 32.006 33.5C32.006 33.6326 32.0587 33.7598 32.1524 33.8536C32.2462 33.9473 32.3734 34 32.506 34C32.6386 34 32.7658 33.9473 32.8596 33.8536C32.9533 33.7598 33.006 33.6326 33.006 33.5C33.006 33.3674 32.9533 33.2402 32.8596 33.1464C32.7658 33.0527 32.6386 33 32.506 33Z"
                    fill="white"
                  /></svg></span
              >{{ $t("text.iBranchTank.tank") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchTanks',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchTanks'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iBranchTank.tank") }}
                </router-link>
              </li>
              <!-- REORDER LEVEL -->
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchReorderLevel',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchReorderLevel'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.reorderLevel.title") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- REPORT -->
          <li
            style="font-size: 12px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_branch_consumption_report' ||
              activeRoute === 'industrial_branch_tank_transactions' ||
              activeRoute === 'industrial_branch_tanks_filled'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Report') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iMasterLayout.reports") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link
                  :to="{
                    name: 'industrial_branch_consumption_report',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_consumption_report'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.consumptionReport") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'industrial_branch_tank_transactions',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_tank_transactions'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.consumptionHistory") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'industrial_branch_tanks_filled',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_tanks_filled'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.tanksFilled") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- EVENT -->
          <li
            style="font-size: 12px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_branch_events'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Events') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_branch_events',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <i
                class="fa fa-calendar-check-o mr-2"
                aria-hidden="true"
                style="font-size: 18px; color: white"
              ></i>
              {{ $t("text.iMasterLayout.events") }}
            </router-link>
          </li>

          <!-- MAINTENENCE -->
          <li
            style="font-size: 12px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrialBranchSchedule_maintenace' ||
              activeRoute === 'industrialBranchAddMaintenance'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Maintenance') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iMasterLayout.maintenance") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchAddMaintenance',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_consumption_report'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.addMaintenance") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchSchedule_maintenace',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchSchedule_maintenace'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.schedules") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- WALLET -->
          <li
            style="font-size: 12px"
            class="list-group-item treeview"
            :class="
              activeRoute === 'industrial_branch_wallet_balance' ||
              activeRoute === 'industrialBranchWalletTransactionDetails'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Wallet') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-shopping-bag"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iMasterLayout.wallet") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li style="font-size: 10px">
                <router-link
                  :to="{
                    name: 'industrial_branch_wallet_balance',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_wallet_balance'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.walletBalance") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'industrialBranchWalletTransactionDetails',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchWalletTransactionDetails'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.transactionsDetails") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- ORDER MANAGEMENT -->
          <li
            style="font-size: 12px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_branch_order_management'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Order management') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'industrial_branch_order_management',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/order-processed.svg" width="20px"
              /></span>
              {{ $t("text.iMasterLayout.orderManagement") }}
            </router-link>
          </li>

          <!-- SUPPORT-->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : null,
            ]"
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/svg/support.svg" width="20px"
              /></span>
              {{ $t("text.cusMasterLayout.supportAdmin") }}
            </router-link>
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="80px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="80px"
                  height="40px"
                />
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>

    <b-navbar toggleable="lg" fixed="top">
      <!-- <b-navbar-toggle id="open_sidebar"></b-navbar-toggle> -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#" class="nav_header" style="font-size: '12p"
            >{{ $t("text.iMasterLayout.hi") }} {{ userName }},
            {{ industryBranchName }} {{ $t("text.iMasterLayout.isRunningOn") }}
            <span class="nav_header_span_label">{{ powerSource }}</span>
            <span
              v-if="lastSeenPower !== $moment(new Date()).format('YYYY-MM-DD')"
              class="nav_header_span_label"
              >{{ $t("text.omit.lastUpdated") }} {{ lastSeenPower }}.</span
            >
            <span v-if="powerSource == `Generator`">
              {{ $t("text.iGroup.genHours") }}
              <span :style="[nextService > 899 ? { color: 'red' } : '']"
                >{{ nextService }} {{ $t("text.iGroup.hours") }}
              </span>
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <b-collapse id="nav-collapse" is-nav>
        <!-- SELECT LANGUAGE -->
        <select
          @change="changeLanguage"
          v-model="usedLang"
          class="w-25 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
        <!-- <select
            @change="changeLanguage"
            class="mr-3"
            style="width: 280px !important"
          >
            <option disabled value="">
              {{ $t("text.cMasterLayout.selectLanguage") }}
            </option>
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select> -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#" class="bell_noti" style="position: relative">
            <img src="@/assets/img/social-media.svg" width="28" />
            <div
              class=""
              style="
                position: absolute;
                right: 0;
                top: -10px;
                height: 65px;
                width: 2px;
                background: lightgrey;
              "
            ></div>
          </b-nav-item>
          <!-- profile and signout -->
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><img src="@/assets/img/signs (2).svg" width="28"
              /></b>
            </template>
            <b-dropdown-item
              ><router-link
                :to="{
                  name: 'industrial_branch_profile',
                  query: {
                    branchId: this.$route.query.branchId,
                    companyId: this.$route.query.companyId,
                    groupId: this.$route.query.groupId,
                  },
                }"
                >{{ $t("text.cMasterLayout.profile") }}</router-link
              ></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.cMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item href="#" class="logout_icon mr-4" @click="signOutUser">
            <img src="@/assets/img/signs (2).svg" width="28" />
          </b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="app__wrapper">
      <div class="empty_div"></div>
      <div class="main_content">
        <div class="inner__main_content">
          <slot>
            <router-view />
          </slot>
        </div>
      </div>
    </div>
    <div class="mobile_navbar">
      <div
        class="mobile_navbar_header"
        :style="[
          windowLoc == 'interswitchenergy'
            ? { backgroundColor: '#11386a' }
            : windowLoc == 'rainoil'
            ? { backgroundColor: '#0a0044' }
            : windowLoc == 'eterna'
            ? { backgroundColor: '#007236' }
            : windowLoc == 'bovas'
            ? { backgroundColor: '#b28b00' }
            : null,
        ]"
      >
        <div class="hamburger_menu_div" @click="toggleMobileNav">
          <span class="hamburger_bar"></span>
          <span class="hamburger_bar mt-2"></span>
          <span class="hamburger_bar mt-2"></span>
        </div>
        <div class="epump_logo text-right">
          <img
            src="@/assets/img/epump_white_logo.svg"
            width="150"
            class="m-logo-margin"
          />
        </div>
      </div>
    </div>
    <transition name="mobile-nav-slide-fade">
      <div
        class="mobil_side_drawer"
        v-if="this.$store.getters.getMobileNavDrawer"
        :style="[
          windowLoc == 'interswitchenergy'
            ? { backgroundColor: '#11386a' }
            : windowLoc == 'rainoil'
            ? { backgroundColor: '#0a0044' }
            : windowLoc == 'eterna'
            ? { backgroundColor: '#007236' }
            : windowLoc == 'bovas'
            ? { backgroundColor: '#b28b00' }
            : null,
        ]"
      >
        <div class="logo_section text-right mt-3">
          <img
            src="@/assets/img/close_btn.png"
            width="35px"
            height="35px"
            @click="toggleMobileNav"
          />
        </div>
        <div class="dasboard_type_button_section mt-3 text-center">
          <div class="mobile_epump_logo">
            <img src="@/assets/img/mobieli_white_epump_logo.svg" width="50px" />
          </div>
          <h3 class="mt-2">{{ userName }}</h3>
          <small>{{ userDetails.email }}</small>
        </div>
        <ul class="list-group mt-4">
          <!-- INDUSTRY ADMIN DASHBOARD -->
          <li
            style="font-size: 14px"
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_admin_dashboard'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="this.$route.query.branchId && !this.$route.query.groupId"
          >
            <router-link
              :to="{
                name: 'industrial_admin_dashboard',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><i
                  class="text-white fa fa-arrow-left"
                  aria-hidden="true"
                  width="20px"
                ></i></span
              >{{ $t("text.cDashboard.backCDashboard") }}
            </router-link>
          </li>

          <!-- INDUSTRY GROUP DASHBOARD -->
          <li
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_group_dashboard'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="this.$route.query.groupId"
          >
            <router-link
              @click.native="toggleMobileNav"
              :to="{
                name: 'industrial_group_dashboard',
                query: {
                  groupID: this.$route.query.groupId,
                  companyId: this.$route.query.companyId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img
                  alt=""
                  src="@/assets/img/dashboard (1).png"
                  width="20px" /></span
              >{{ $t("text.omit.backToGroupDash") }}
            </router-link>
          </li>

          <!-- INDUSTRY BRANCH DASHBOARD -->
          <li
            class="list-group-item"
            :class="[
              activeRoute === 'IndustrialBranchDashboard'
                ? 'navbar_item_active'
                : null,
            ]"
          >
            <router-link
              @click.native="toggleMobileNav"
              :to="{
                name: 'IndustrialBranchDashboard',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img
                  alt=""
                  src="@/assets/img/dashboard (1).png"
                  width="20px" /></span
              >{{ $t("text.iMasterLayout.dashboard") }}
            </router-link>
          </li>

          <!-- TANK -->
          <li
            class="list-group-item treeview"
            @click="toggleTanks"
            :class="
              activeRoute === 'industrialBranchTanks' ||
              activeRoute === 'industrialBranchReorderLevel'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Tank') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iBranchTank.tank") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul
              class="treeview-menu"
              :style="
                activeDropdown === 'tanks'
                  ? { display: 'block' }
                  : { display: 'none' }
              "
            >
              <!-- <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{ name: 'industrial_branch_tanks_filled', query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    }, }"
                  :class="
                    activeRoute === 'industrial_branch_tanks_filled'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  Tanks
                </router-link>
              </li> -->
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrialBranchTanks',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchTanks' ? 'active' : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iBranchTank.tank") }}
                </router-link>
              </li>
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrialBranchReorderLevel',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchReorderLevel'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.reorderLevel.title") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- REPORT -->
          <li
            class="list-group-item treeview"
            @click="toggleReports"
            :class="
              activeRoute === 'industrial_branch_consumption_report' ||
              activeRoute === 'industrial_branch_tank_transactions' ||
              activeRoute === 'industrial_branch_tanks_filled'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Report') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iMasterLayout.reports") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul
              class="treeview-menu"
              :style="
                activeDropdown === 'reports'
                  ? { display: 'block' }
                  : { display: 'none' }
              "
            >
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrial_branch_consumption_report',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_consumption_report'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.consumptionReport") }}
                </router-link>
              </li>

              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrial_branch_tank_transactions',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_tank_transactions'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.consumptionHistory") }}
                </router-link>
              </li>

              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrial_branch_tanks_filled',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_tanks_filled'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.tanksFilled") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- EVENTS -->
          <!-- <li
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_branch_events'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Events') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              @click.native="toggleMobileNav"
              :to="{ name: 'industrial_branch_events' }"
              class="vue_router_link"
            >
              <i
                class="fa fa-calendar-check-o mr-2"
                aria-hidden="true"
                style="font-size: 18px; color: white"
              ></i>
              {{ $t("text.iMasterLayout.events") }}
            </router-link>
          </li> -->

          <!-- MAINTENANCE -->
          <li
            class="list-group-item treeview"
            @click="toggleMaintenance"
            :class="
              activeRoute === 'industrialBranchSchedule_maintenace' ||
              activeRoute === 'industrialBranchAddMaintenance'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Maintenance') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-cogs"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iMasterLayout.maintenance") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul
              class="treeview-menu"
              :style="
                activeDropdown === 'maint'
                  ? { display: 'block' }
                  : { display: 'none' }
              "
            >
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrialBranchAddMaintenance',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchAddMaintenance'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.addMaintenance") }}
                </router-link>
              </li>
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrialBranchSchedule_maintenace',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchSchedule_maintenace'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.schedules") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- WALLET -->
          <li
            class="list-group-item treeview"
            @click="toggleWallet"
            :class="
              activeRoute === 'industrial_branch_wallet_balance' ||
              activeRoute === 'industrialBranchWalletTransactionDetails'
                ? 'navbar_item_active open'
                : ''
            "
            v-if="
              comPlanFeatures.includes('Wallet') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-shopping-bag"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.iMasterLayout.wallet") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul
              class="treeview-menu"
              :style="
                activeDropdown === 'wallet'
                  ? { display: 'block' }
                  : { display: 'none' }
              "
            >
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrial_branch_wallet_balance',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrial_branch_wallet_balance'
                      ? 'navbar_item_active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.walletBalance") }}
                </router-link>
              </li>
              <li>
                <router-link
                  @click.native="toggleMobileNav"
                  :to="{
                    name: 'industrialBranchWalletTransactionDetails',
                    query: {
                      branchId: this.$route.query.branchId,
                      companyId: this.$route.query.companyId,
                      groupId: this.$route.query.groupId,
                    },
                  }"
                  :class="
                    activeRoute === 'industrialBranchWalletTransactionDetails'
                      ? 'active'
                      : ''
                  "
                  class="vue_router_link"
                >
                  {{ $t("text.iMasterLayout.transactionsDetails") }}
                </router-link>
              </li>
            </ul>
          </li>

          <!-- ORDER MANAGEMENT -->
          <li
            class="list-group-item"
            :class="[
              activeRoute === 'industrial_branch_order_management'
                ? 'navbar_item_active'
                : null,
            ]"
            v-if="
              comPlanFeatures.includes('Order management') ||
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              @click.native="toggleMobileNav"
              :to="{
                name: 'industrial_branch_order_management',
                query: {
                  branchId: this.$route.query.branchId,
                  companyId: this.$route.query.companyId,
                  groupId: this.$route.query.groupId,
                },
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/order-processed.svg" width="20px"
              /></span>
              {{ $t("text.iMasterLayout.orderManagement") }}
            </router-link>
          </li>

          <!-- SUPPORT-->
          <li
            style="font-size: 10px"
            class="list-group-item"
            :class="[
              activeRoute === 'supportCompanies' ? 'navbar_item_active' : null,
            ]"
            v-if="
              userInfo.roles.includes('SupportAdmin') ||
              userInfo.roles.includes('PartnerAdmin')
            "
          >
            <router-link
              :to="{
                name: 'supportCompanies',
              }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img
                  src="https://test-admin.epump.ng/img/profile.c07aa991.svg"
                  width="20px"
              /></span>
              {{ $t("text.cusMasterLayout.supportAdmin") }}
            </router-link>
          </li>

          <!-- SELECT LANGUAGE -->

          <li class="list-group-item treeview mb-4" @click="toggleLanguage">
            <a href="#">
              <span class="mr-3"
                ><span
                  class="fa fa-shopping-bag"
                  aria-hidden="true"
                  style="color: white"
                ></span></span
              >{{ $t("text.cMasterLayout.selectLanguage") }}
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul
              class="treeview-menu"
              :style="
                activeDropdown === 'lang'
                  ? { display: 'block' }
                  : { display: 'none' }
              "
            >
              <li
                class="list-group-item treeview mt-3"
                @click="changeLanguage('en')"
              >
                English
              </li>
              <li
                class="list-group-item treeview mt-3"
                @click="changeLanguage('fr')"
              >
                French
              </li>
            </ul>
          </li>

          <!-- SIGN OUT -->
          <li
            class="list-group-item"
            @click="signOutUser"
            v-b-tooltip.hover
            title="Sign Out"
          >
            <span class="mr-3"
              ><img src="@/assets/img/fast.png" width="20px" /></span
            >{{ $t("text.iMasterLayout.signOut") }}
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="60px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="60px"
                  height="30px"
                />
              </div>
            </div>
          </div>
        </ul>
      </div>
    </transition>
    <div class="mobile-nav_header">
      {{ $t("text.iMasterLayout.hi") }} {{ userName }},
      {{ industryBranchName }} {{ $t("text.iMasterLayout.isRunningOn") }}
      <span class="nav_header_span_label">{{ powerSource }}.</span>
      <span
        v-if="lastSeenPower !== $moment(new Date()).format('YYYY-MM-DD')"
        class="nav_header_span_label"
        >{{ $t("text.omit.lastUpdated") }} {{ lastSeenPower }}.</span
      >
      <span v-if="powerSource == `Generator`"></span>
      {{ $t("text.iGroup.genHours") }}
      <span :style="[nextService > 899 ? { color: 'red' } : '']"
        >{{ nextService }} {{ $t("text.iGroup.hours") }}
      </span>
    </div>
  </div>
</template>

<script>
import JQuery from "jquery";
import backImg from "@/assets/img/pattern_img.png";
import configObject from "@/config";
import WarningModal from "@/components/modals/Dashboard/warningModal";
import SuspendedModal from "@/components/modals/Dashboard/suspendedModal";
let $ = JQuery;

export default {
  title: "Industrial Dashboard",
  name: "MasterLayout",
  components: {
    WarningModal,
    SuspendedModal,
    // StarRating,
  },
  data() {
    return {
      statusInfo: {},
      backImg,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : { name: "STATION" },
      powerSource: "",
      lastSeenPower: "",
      showWallet: false,
      showLang: false,
      showTanks: false,
      showReports: false,
      showMaintenance: false,
      activeDropdown: "",
      branch: "Branch",
      nextService: "",
      startedDtae: "",
      branches: null,
      industryBranch: null,
      industryBranchId: null,
      industryBranchName: "",
      companyId: "",
      industrialBranch: this.$route.query.branchId
        ? this.$route.query.branchId
        : null,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
      comPlanFeatures: localStorage.getItem("subPlanFeatures")
        ? JSON.parse(localStorage.getItem("subPlanFeatures"))
        : [],
    };
  },
  computed: {
    userName() {
      if (localStorage.getItem("userDetails")) {
        return this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        return "Username";
      }
    },
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
  },
  beforeMount() {
    this.activeRoute = this.$route.name;
  },
  watch: {
    industrialBranch() {
      this.getPowerStatus();
    },
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        //this.getPowerUseDailyUsage();
        //this.getPowerUseDetails();
        this.getServiceDay();
      }
    },
    branches() {
      const industrialBranch = this.branches.filter(
        (branch) => branch.id == this.$route.query.branchId
      );
      this.$eventHub.$emit("gotIndustryBranch", true);
      this.$eventHub.$emit("industryBranch", industrialBranch[0]);
    },
  },
  created() {
    // if (this.$route.query.companyId) {
    //   console.log("branches");
    //   this.getBranches();
    // } else if (!this.$route.query.branchId) {
    //   console.log("branch");
    //   this.getBranch();
    // }
    // console.log(this.$route.name);
    this.getBranch();
    if (this.$route.query.companyId && this.$route.query.branchId) {
      this.checkStatus();
    }
    // this.checkStatus();
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
    });
  },

  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    if (screen.width > 575) {
      $(".treeview > a").on("click", function (e) {
        e.preventDefault();
        var me = $(this);

        if (me.parent("li").hasClass("open")) {
          //close me
          me.parent("li").removeClass("open");
        } else {
          // Open me & close others
          $(".treeview").removeClass("open");
          me.parent("li").addClass("open");
        }
      });
    }

    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $(".navbar").addClass("navbar-fixed");
      }
      if ($(window).scrollTop() < 20) {
        $(".navbar").removeClass("navbar-fixed");
      }
    });
    if (this.userDetails.role === "IndustryManager") {
      this.getBranch();
    } else {
      this.$eventHub.$emit("gotBranch", true);
    }
    // this.computeUserDetails();
  },
  methods: {
    changeLanguage(e) {
      if (e == "en" || e == "fr") {
        this.$store.commit("setLanguage", e);
        const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
        this.$root.$i18n.locale = locale;
        localStorage.setItem("locale", locale);
        return;
      }

      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    // getBranches() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Company/Branches/${this.$route.query.companyId}`,
    //       configObject.authConfig()
    //     )
    //     .then((res) => {
    //       res.data.sort((a, b) => {
    //         return a.name.toLowerCase() > b.name.toLowerCase()
    //           ? 1
    //           : b.name.toLowerCase() > a.name.toLowerCase()
    //           ? -1
    //           : 0;
    //       });
    //       this.branches = res.data;
    //     })
    //     .catch((error) => {
    //       this.$toast(error.response.data.message, {
    //         type: "error",
    //         timeout: 3000,
    //       });
    //     });
    // },
    getBranches() {
      const useId = this.$route.query.companyId
        ? this.$route.query.companyId
        : "";
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${useId}`,
          configObject.authConfig()
        )
        .then((response) => {
          const companyBranch = response.data.filter(
            (cur) => cur.id === this.$route.query.branchId
          );

          localStorage.setItem("totalBranches", JSON.stringify(companyBranch));
          if (companyBranch.length > 0) {
            this.branch = companyBranch[0];
            this.industryBranchId = companyBranch[0].id;
            this.industrialBranch = companyBranch[0];
            this.industryBranchName = companyBranch[0].name;
            this.companyId = companyBranch[0].companyId;
            this.getBranchReorderLevel(companyBranch[0].id);
            this.$eventHub.$emit("gotIndustryBranch", true);
            this.$eventHub.$emit("industryBranch", companyBranch[0]);
            this.checkStatus();
          } else {
            // console.log("branches incoorect");
            //   this.$eventHub.$emit("gotIndustryBranch", false);
          }
        })
        .catch((error) => {
          // console.log(error);
          // if (error.response && error.response.status == 401) {
          //   return;
          // }
          // if (error.message && error.message === "Network Error") {
          //   this.$toast.open({
          //     message: "Network Error, Please Check Your Internet Connection",
          //     type: "error",
          //     duration: 5000,
          //   });
          // } else {
          //   this.$toast.open({
          //     message: "An Error Occured",
          //     type: "error",
          //     duration: 5000,
          //   });
          // }
        });
    },
    getBranchReorderLevel(branchID) {
      // console.log(this.$route.name);
      const prostatShown = this.$store.getters.getProstatShown;
      if (prostatShown) {
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/BranchProductReorderLevel/${branchID}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response.data);
          response.data
            // .filter((fr) => {
            //   return fr.level != "Normal";
            // })
            .forEach((fr) => {
              const frText = `${fr.level}  &#x1F5D9`;
              if (fr.levelPercentage <= 0) {
                this.$toast.open({
                  message: frText,
                  position: "top-right",
                  type: "error",
                  duration: 20000,
                  dismissible: true,
                });
              } else {
                this.$toast.open({
                  message: frText,
                  position: "top-right",
                  type: "warning",
                  duration: 20000,
                  dismissible: true,
                });
              }
            });
          this.$store.commit("setProstatShown", true);
        })
        .catch((error) => {});
    },

    checkStatus() {
      const modalShown = this.$store.getters.getBranchModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getBranchStatusInfo;
        return;
      }
      const endpoint = this.$route.query.branchId
        ? `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }&branchId=${this.$route.query.branchId}`
        : `${configObject.apiBaseUrl}/Invoices/status?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }&branchId=${this.branch.id}`;
      this.axios
        .get(endpoint, configObject.authConfig())
        .then((response) => {
          this.statusInfo = response.data;
          if (response.data.status == 1) {
            if (!modalShown) {
              if (
                !this.userInfo.roles.includes("SupportAdmin") &&
                !this.userInfo.roles.includes("PartnerAdmin")
              ) {
                this.showWarningModal();
                this.$store.commit("setBranchModalShown", true);
              }
            }
          }
          if (response.data.status == 2) {
            if (
              !this.userInfo.roles.includes("SupportAdmin") &&
              !this.userInfo.roles.includes("PartnerAdmin")
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setBranchStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },

    assignValues(branch) {
      // console.log(branch);
      this.branch = branch[0];
      this.industrialBranch = branch[0];
      this.industryBranchId = branch[0].id;
      this.industryBranchName = branch[0].name;
      this.$eventHub.$emit("gotIndustryBranch", true);
      this.$eventHub.$emit("industryBranch", branch[0]);
    },
    getBranch() {
      let api;
      if (this.$route.query.branchId && this.$route.query.groupId) {
        const useId = this.$route.query.groupId
          ? this.$route.query.groupId
          : "";

        api = `/Company/GroupBranches/${useId}`;
      } else if (this.$route.query.branchId) {
        const useId = this.$route.query.companyId
          ? this.$route.query.companyId
          : "";

        api = `/Company/Branches/${useId}`;
        // console.log("jskds");
        // this.assignValues(industryBranch);
      } else {
        api = `/Company/MyBranches`;
      }

      this.axios
        .get(`${configObject.apiBaseUrl}${api}`, configObject.authConfig())
        .then((response) => {
          //console.log("branch worked");
          localStorage.setItem("totalBranches", JSON.stringify(response.data));
          if (response.data.length > 0) {
            if (this.$route.query.companyId) {
              let branchData = response.data.filter(
                (branchDetails) =>
                  branchDetails.id === this.$route.query.branchId
              );

              this.assignValues(branchData);
            } else {
              this.assignValues(response.data);
            }
            this.checkStatus();

            // Logic for subscription plan feature
            let subPlanFeat;
            let isSubPlanFeat;
            subPlanFeat = response.data[0].planFeatures;
            isSubPlanFeat = localStorage.getItem("subPlanFeatures");
            if (!isSubPlanFeat && subPlanFeat !== null) {
              localStorage.setItem(
                "subPlanFeatures",
                JSON.stringify(subPlanFeat)
              );
              this.comPlanFeatures = JSON.parse(
                localStorage.getItem("subPlanFeatures")
              );
            }
            // this.comPlanFeatures = response.data[0].planFeatures;
            // console.log(this.comPlanFeatures);
            // Logic for subscription plan feature ended

            this.getBranchReorderLevel(response.data[0].id);

            // this.branch = response.data[0];
            // this.industrialBranch = response.data[0];
            // this.industryBranchId = response.data[0].id
            // this.industryBranchName = response.data[0].name;
            // this.$eventHub.$emit("gotIndustryBranch", true);
            // this.$eventHub.$emit("industryBranch", response.data[0]);
          } else {
            // console.log("branch incoorect");
            this.$eventHub.$emit("gotIndustryBranch", false);
            this.checkStatus();
          }
        })
        .catch((error) => {});
    },
    getBalance() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BranchRemisWallet/{branchId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.Balance = res.data;
        })
        .catch((error) => {});
    },
    getServiceDay() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/NextServiceDay/${this.industryBranch.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.nextService = parseInt(res.data.totalHour);
          this.startedDate = new Date(res.data.startedDate).toDateString();
          //console.log(this.nextService)
          // console.log(res.data.hoursLeftBeforeService);
        })
        .catch((err) => {
          // console.log(err.message);
        });
    },
    getBalance() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BranchRemisWallet/${branchId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.Balance = res.data;
        })
        .catch((error) => {});
    },
    toggleWallet() {
      this.showWallet = !this.showWallet;
      if (this.showWallet === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "wallet";
      }
    },

    toggleLanguage() {
      this.showLang = !this.showLang;
      if (this.showLang === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "lang";
      }
    },

    signOutUser() {
      const answer = window.confirm(
        this.$t("text.iMasterLayout.confirmLogout")
      );
      if (answer) {
        this.$store.commit("setModalShown", false);
        this.$store.commit("setProstatShown", false);
        this.$store.dispatch("logout");
        this.$router.push({ path: "/" });
      }
    },
    toggleTanks() {
      this.showTanks = !this.showTanks;
      if (this.showTanks === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "tanks";
      }
    },
    toggleReports() {
      this.showReports = !this.showReports;
      if (this.showReports === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "reports";
      }
    },
    toggleMaintenance() {
      this.showMaintenance = !this.showMaintenance;
      if (this.showMaintenance === false) {
        this.activeDropdown = "";
      } else {
        this.activeDropdown = "maint";
      }
    },
    toggleMobileNav() {
      this.$store.commit("toggleMobileNavDrawer");
    },
    getPowerStatus() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerStatus/${this.industryBranchId}`,
          configObject.authConfig()
        )
        .then((res) => {
          console.log(res);
          if (res.data.source === "Nill") {
            this.powerSource = "No Power Source";
          } else {
            this.powerSource = res.data.source;
          }

          this.lastSeenPower = this.$moment(res.data.lastSeen).format(
            "YYYY-MM-DD"
          );
          this.$moment(new Date()).format("YYYY-MM-DD");

          //console.log(this.powerSource);
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/styles_new.scss";

@media screen and (max-width: 600px) {
  .inner__main_content {
    margin-top: 70px !important;
  }

  .mobile-nav_header {
    font-size: 14px;
    color: black;
    background-color: white;
    width: 100%;
    position: fixed;
    padding: 20px 40px;
    top: 60px;
  }
}
@import url("https://cdn.syncfusion.com/ej2/material.css");
</style>
